export const HAS_OFFER_SOURCE = 'search';
